import React, {Component} from 'react';
import {gpn} from "../GPN"
import config from "../config";

import {Route, Routes} from "react-router-dom";
import Login from "./Login";
import Init from "./Init";
import SideBar from "../sections/SideBar";
import axios from "axios";
import Icon from "../sections/MUI/Icon";
import {toast} from "react-toastify";
import Admins from "./Admins";
import Categories from "./Categories";
import EditCategory from "./EditCategory";
import Regions from "./Regions";
import Services from "./Services";
import EditService from "./EditService";
import Experts from "./Experts";
import EditExpert from "./EditExpert";
import Users from "./Users";
import EditUser from "./EditUser";
import Orders from "./Orders";
import EditOrder from "./EditOrder";
import Payments from "./Payments";
import Dashboard from "./Dashboard";
import CreateOrder from "./CreateOrder";
import Chats from "./Chats";
import ChatMessage from "./ChatMessage";

class App extends Component {

    state = {
        firstName: "",
        lastName: "",
        permissions: [],
        phoneNumber: ""
    };

    componentDidMount() {
        if (config.token === "" && document.location.pathname !== "/login" && document.location.pathname !== "/init") {
            document.location.href = "/login";
        } else {
            this.getInfo()
        }
    }


    isLoginPage() {
        return document.location.pathname === "/login" || document.location.pathname === "/init"
    }

    getInfo() {
        axios.get(`${config.api}/admin/info?token=${config.token}`)
            .then(r => {
                this.setState({
                    ...r.data.result
                });
            })
            .catch(err => {

            });
    }

    render() {
        const {firstName, lastName, permissions, phoneNumber} = this.state;
        const {navigate} = this.props;
        const ro = {
            navigate,
            firstName,
            lastName,
            permissions,
            phoneNumber
        };
        return (
            <div className="row">
                {
                    !this.isLoginPage() ?
                        <SideBar {...ro}/>
                        : null
                }
                <div className={this.isLoginPage() ? "col-12" : "col-md-8"}>
                    {
                        !this.isLoginPage() ?
                            <header>
                                <p>سلام&nbsp;{firstName}&nbsp;{lastName}&nbsp;عزیز؛ به پنل مدیریت خوش آمدید&nbsp;<Icon
                                    i="person-from-portal" onClick={() => {
                                    localStorage.removeItem("token");
                                    toast.success("در حال خروج ...");
                                    setTimeout(() => {
                                        document.location.href = "/login";
                                    }, 2000)
                                }}/></p>
                            </header> : null
                    }

                    <main>
                        <Routes>
                            <Route path="/login" element={<Login {...ro}/>}/>
                            <Route path="/init" element={<Init {...ro}/>}/>
                            {config.hasAccess(permissions, "dashboard") ?
                                <>
                                    <Route path="/" element={<Dashboard {...ro}/>}/>
                                    <Route path="/dashboard" element={<Dashboard {...ro}/>}/>
                                </>
                                : null}
                            {config.hasAccess(permissions, "admin") ?
                                <Route path="/admins" element={<Admins {...ro}/>}/>
                                : null}
                            {config.hasAccess(permissions, "category") ?
                                <>
                                    <Route path="/categories" element={<Categories {...ro}/>}/>
                                    <Route path="/category/:id" element={<EditCategory {...ro}/>}/>
                                </>
                                : null}
                            {
                                config.hasAccess(permissions, "region") ?
                                    <>
                                        <Route path="/regions" element={<Regions {...ro}/>}/>
                                    </> : null
                            }

                            {
                                config.hasAccess(permissions, "service") ?
                                    <>
                                        <Route path="/services" element={<Services {...ro}/>}/>
                                        <Route path="/service/:id" element={<EditService {...ro}/>}/>
                                    </>
                                    : null
                            }

                            {
                                config.hasAccess(permissions, "expert") ?
                                    <>
                                        <Route path="/experts" element={<Experts {...ro}/>}/>
                                        <Route path="/expert/:id" element={<EditExpert {...ro}/>}/>
                                    </> : null
                            }
                            {config.hasAccess(permissions, "user") ?
                                <>
                                    <Route path="/users" element={<Users {...ro}/>}/>
                                    <Route path="/user/:id" element={<EditUser {...ro}/>}/>
                                </>
                                : null}

                            {config.hasAccess(permissions, "order") ?
                                <>
                                    <Route path="/orders" element={<Orders {...ro}/>}/>
                                    <Route path="/order/new" element={<CreateOrder {...ro}/>}/>
                                    <Route path="/order/:id" element={<EditOrder {...ro}/>}/>
                                </>
                                : null}

                            {config.hasAccess(permissions, "payment") ?
                                <>
                                    <Route path="/payments" element={<Payments {...ro}/>}/>
                                </>
                                : null}
                            {config.hasAccess(permissions, "chats") ?
                                <>
                                    <Route path="/chats" element={<Chats {...ro}/>}/>
                                    <Route path="/chat/messages/:id" element={<ChatMessage {...ro}/>}/>
                                </>
                                : null}
                        </Routes>
                    </main>

                </div>

            </div>
        );
    }
}

export default gpn(App);